export const MECHANIC_ASSET_STATUS_VARIANTS = Object.freeze({
  stock: 'success',
  reserved: 'warning',
  in_transfer: 'info',
  on_object: 'primary',
  repair_acceptance: 'warning',
  diagnostics: 'warning',
  waiting_parts: 'warning',
  repair_in_progress: 'danger',
  quality_check: 'info',
  ready_after_repair: 'success',
  maintenance_due: 'warning',
  maintenance_in_progress: 'info',
  blocked: 'dark',
  lost: 'dark',
  writeoff_pending: 'secondary',
  written_off: 'secondary',
  rented_out: 'primary',
  sold: 'secondary',
  archive: 'secondary'
});

export const MECHANIC_ASSET_CATALOG_CATEGORY_LABELS = Object.freeze({
  machinery: 'Техника',
  vehicle: 'Транспорт',
  mechanism: 'Механизм',
  equipment: 'Оборудование',
  tool: 'Инструмент',
  spare_part: 'Запчасти',
  consumable: 'Расходники',
  inventory: 'Инвентарь',
  other: 'Прочее'
});

export const MECHANIC_ASSET_ACCOUNTING_TYPE_LABELS = Object.freeze({
  inventory: 'Инвентарный',
  quantity: 'Количественный',
  kit: 'Комплект'
});

export const MECHANIC_ASSET_WAREHOUSE_TYPE_LABELS = Object.freeze({
  warehouse: 'Склад',
  repair: 'Ремзона',
  storage: 'Хранение'
});

export function getMechanicAssetStatusVariant(status) {
  return MECHANIC_ASSET_STATUS_VARIANTS[status] || 'secondary';
}
